import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=070742fc&scoped=true"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=070742fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070742fc",
  null
  
)

export default component.exports